"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckOfflineIncome = exports.offlineIncomeDivider = void 0;
var _1 = require(".");
var data_1 = require("./data");
var lib_1 = require("./lib/lib");
var math_1 = require("./lib/math");
var popupElement = document.querySelector("#offline-income-popup");
exports.offlineIncomeDivider = 2; // offline income 2 times smaller than in game income
var CheckOfflineIncome = function (offlineDurationMs) {
    var offlineIncomeData = (0, lib_1.CalcOfflineIncomeData)();
    if (offlineDurationMs > offlineIncomeData.maxTimeMs)
        offlineDurationMs = offlineIncomeData.maxTimeMs;
    if (offlineDurationMs <= 0)
        return;
    var offlineIncome = (0, lib_1.CalcIncomePerSecond)() * (offlineDurationMs / 1000);
    offlineIncome /= exports.offlineIncomeDivider; // 5 times smaller than what it would have been if you would have been playing the game
    if (offlineIncome > offlineIncomeData.maxMoney)
        offlineIncome = offlineIncomeData.maxMoney;
    offlineIncome = Math.floor(offlineIncome);
    if (offlineIncome && !_1.isSimulated) {
        popupElement.style.display = "flex";
        document.querySelector("#offline-money").innerHTML = (0, math_1.FormatNumber)(offlineIncome);
        document.querySelector("#max-offline-money").innerHTML = (0, math_1.FormatNumber)(offlineIncomeData.maxMoney);
        document.querySelector("#offline-income-collect-button").addEventListener("click", function () {
            data_1.GameData.money += offlineIncome;
            (0, data_1.SaveGameData)();
            (0, _1.UpdateMoneyText)();
            popupElement.style.display = "none";
        });
    }
    return offlineIncome;
};
exports.CheckOfflineIncome = CheckOfflineIncome;
